var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"mr-2",attrs:{"href":_vm.link,"title":_vm.title || _vm.link,"color":_vm.color,"target":_vm.target,"depressed":"","x-small":"","fab":"","dark":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }